var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "42.463 -67.374 293.348 289.95",
    width: 293.348,
    height: 289.95,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 334.838 116.731 C 334.838 158.319 317.303 195.811 289.224 222.218 C 288.758 221.657 288.282 221.119 287.799 220.603 C 285.589 218.241 283.001 216.034 280.28 214.888 C 277.67 213.789 277.384 213.98 271.858 213.685 C 256.571 212.87 186.722 213.242 163.578 213.685 C 150.28 213.94 144.822 213.668 136.508 214.888 C 128.895 216.006 119.629 219.938 115.453 220.302 C 113.279 220.492 113.165 219.823 111.242 219.701 C 108.271 219.513 102.563 218.867 98.61 219.701 C 96.055 220.239 93.343 221.087 91 222.321 C 62.856 195.908 45.276 158.373 45.276 116.731 C 45.276 36.771 110.097 -28.05 190.057 -28.05 C 270.017 -28.05 334.838 36.771 334.838 116.731 Z",
    style: {
      fill: "rgb(138, 76, 168)",
      fillRule: "nonzero"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1, 0, 0, 1, 50.073609, -52.179775)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140,36 C170.927946,36 196,61.072054 196,92 L196.000809,98.1660527 C201.675838,99.1185422 206,104.05429 206,110 L206,124 C206,130.052417 201.519235,135.058294 195.693975,135.881364 C193.627928,155.686472 181.237929,172.421678 164.001014,180.610469 L164,199 L168,199 C207.764502,199 240,231.235498 240,271 L240,280 L40,280 L40,271 C40,231.235498 72.235498,199 112,199 L116,199 L115.999984,180.610943 C98.7625487,172.422324 86.3721119,155.686854 84.3051107,135.88097 C78.480765,135.058294 74,130.052417 74,124 L74,110 C74,104.053942 78.3246685,99.1179645 84.0001873,98.1658855 L84,92 C84,61.072054 109.072054,36 140,36 Z",
    id: "path-3",
    fill: "#eac7a8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.998216,180.610103 C123.272713,184.066155 131.410519,186 140,186 C148.588785,186 156.725969,184.066469 164.000016,180.610943 L164.000353,185.94579 C157.441661,190.398372 149.524652,193 141,193 C131.589035,193 122.918635,189.829263 115.998807,184.497795 Z",
    id: "path-4",
    fillOpacity: 0.24,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g-2",
    transform: "translate(112.000000, 122.000000) scale(1 1)",
    fill: "#000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,8 C16,12.418278 21.372583,16 28,16 L28,16 C34.627417,16 40,12.418278 40,8",
    id: "g-2",
    fillOpacity: 0.16,
    fill: "#000"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-4",
    transform: "translate(8.000000, 170.000000) scale(1 1)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M156.001177,13.0710173 C174.10124,15.0965377 188,20.6637035 188,35.0769231 L187.994775,34.6445513 C213.853089,45.5674185 232,71.1642324 232,100.999485 L232,110 L32,110 L32,100.999485 C32,71.1638494 50.1473773,45.5667611 76.0062213,34.6441305 C76.2809798,20.5514284 90.0819496,15.075891 107.999825,13.0709052 L108,32 C108,45.254834 118.745166,56 132,56 C145.254834,56 156,45.254834 156,32 L156,32 Z",
    id: "path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g-5",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-1",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.001177,13.0710173 C174.10124,15.0965377 188,20.6637035 188,35.0769231 L187.994775,34.6445513 C213.853089,45.5674185 232,71.1642324 232,100.999485 L232,110 L32,110 L32,100.999485 C32,71.1638494 50.1473773,45.5667611 76.0062213,34.6441305 C76.2809798,20.5514284 90.0819496,15.075891 107.999825,13.0709052 L108,32 C108,45.254834 118.745166,56 132,56 C145.254834,56 156,45.254834 156,32 L156,32 Z",
    transform: "matrix(1, 0, 0, 1, 0, 0)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M156.001177,13.0710173 C174.10124,15.0965377 188,20.6637035 188,35.0769231 L187.994775,34.6445513 C213.853089,45.5674185 232,71.1642324 232,100.999485 L232,110 L32,110 L32,100.999485 C32,71.1638494 50.1473773,45.5667611 76.0062213,34.6441305 C76.2809798,20.5514284 90.0819496,15.075891 107.999825,13.0709052 L108,32 C108,45.254834 118.745166,56 132,56 C145.254834,56 156,45.254834 156,32 L156,32 Z",
    id: "path-6",
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    fill: "#191227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.999618,61.7388852 L102,110 L95,110 L94.9990839,58.149718 C97.2029904,59.4596568 99.5461861,60.6605136 101.999618,61.7388852 Z M169.001367,58.1494501 L169,98.5 C169,100.432997 167.432997,102 165.5,102 C163.567003,102 162,100.432997 162,98.5 L162.001384,61.7384448 C164.454619,60.6601132 166.797629,59.4593148 169.001367,58.1494501 Z",
    id: "path-7",
    fill: "#F4F4F4",
    mask: "url(#mask-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.041065,12.7245804 C188.091243,15.5714792 198.5,21.2431784 198.5,32.3076923 C198.5,52.0200095 165.462319,68 132,68 C98.5376807,68 65.5,52.0200095 65.5,32.3076923 C65.5,21.2431784 75.908757,15.5714792 90.9589345,12.7245804 C81.8748056,16.0747223 76,21.706273 76,31.0769231 C76,51.4689754 103.821205,68 132,68 C160.178795,68 188,51.4689754 188,31.0769231 C188,21.9004995 182.366206,16.3097803 173.60124,12.9358572 Z",
    id: "path-8",
    fillOpacity: 0.16,
    fill: "#000",
    mask: "url(#mask-1)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-6",
    transform: "translate(86.000000, 134.000000) scale(1 1)",
    fill: "#000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-7",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40,15 C40,22.7319865 46.2680135,29 54,29 L54,29 C61.7319865,29 68,22.7319865 68,15",
    id: "g-6",
    fillOpacity: 0.7,
    fill: "#000"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-8",
    transform: "translate(84.000000, 90.000000) scale(1 1)",
    fill: "#000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-9",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1601674,22.4473116 C18.006676,18.648508 22.1644225,16 26.9975803,16 C31.8136766,16 35.9591217,18.629842 37.8153518,22.4071242 C38.3667605,23.5291977 37.5821037,24.4474817 36.790607,23.7670228 C34.3395063,21.6597833 30.8587163,20.3437884 26.9975803,20.3437884 C23.2572061,20.3437884 19.8737584,21.5787519 17.4375392,23.5716412 C16.5467928,24.3002944 15.6201012,23.5583844 16.1601674,22.4473116 Z",
    id: "path-9",
    fillOpacity: 0.6,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1601674,22.4473116 C76.006676,18.648508 80.1644225,16 84.9975803,16 C89.8136766,16 93.9591217,18.629842 95.8153518,22.4071242 C96.3667605,23.5291977 95.5821037,24.4474817 94.790607,23.7670228 C92.3395063,21.6597833 88.8587163,20.3437884 84.9975803,20.3437884 C81.2572061,20.3437884 77.8737584,21.5787519 75.4375392,23.5716412 C74.5467928,24.3002944 73.6201012,23.5583844 74.1601674,22.4473116 Z",
    id: "path-9",
    fillOpacity: 0.6,
    fill: "#000"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-10",
    transform: "translate(84.000000, 82.000000) scale(1 1)",
    fill: "#000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-11",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-12",
    transform: "translate(12.000000, 6.000000)",
    fill: "#000",
    fillOpacity: 0.6,
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.63024536,11.1585767 C7.54515501,5.64986673 18.2779197,2.56083721 27.5230268,4.83118046 C28.5957248,5.0946055 29.6788665,4.43856013 29.9422916,3.36586212 C30.2057166,2.2931641 29.5496712,1.21002236 28.4769732,0.94659732 C17.7403633,-1.69001789 5.31209962,1.88699832 0.369754639,8.84142326 C-0.270109626,9.74178291 -0.0589363917,10.9903811 0.84142326,11.6302454 C1.74178291,12.2701096 2.9903811,12.0589364 3.63024536,11.1585767 Z",
    id: "path-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6302454,11.1585767 C65.545155,5.64986673 76.2779197,2.56083721 85.5230268,4.83118046 C86.5957248,5.0946055 87.6788665,4.43856013 87.9422916,3.36586212 C88.2057166,2.2931641 87.5496712,1.21002236 86.4769732,0.94659732 C75.7403633,-1.69001789 63.3120996,1.88699832 58.3697546,8.84142326 C57.7298904,9.74178291 57.9410636,10.9903811 58.8414233,11.6302454 C59.7417829,12.2701096 60.9903811,12.0589364 61.6302454,11.1585767 Z",
    id: "path-10",
    transform: "translate(73.000154, 6.039198) scale(-1, 1) translate(-73.000154, -6.039198)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g-13",
    transform: "translate(57.000000, 72.000000) scale(1 1)",
    fill: "#000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-14",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "g-15",
    transform: "translate(7.000000, 0.000000) scale(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hairstyle/Quiff",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.006509,3.44933517 C177.879226,17.2806498 178.971434,15.1527552 187.709094,11.9609134 C186.252817,21.891088 181.155849,27.5654735 172.418188,28.9840699 C181.155849,31.8212626 191.349786,30.4026663 203,24.7282808 C201.856264,38.0979927 197.922013,48.8875593 191.933265,57.168324 C190.874178,90.1306073 189.063442,107.376924 186.5,108.90625 C184.198425,110.279349 182.503625,96.5692451 181.415602,67.7759389 C160.700688,82.9709151 128.318602,81.0328144 97.6913917,63.2647198 C92.0755174,69.6952074 87.2016325,74.1549165 83.0697642,76.6435409 C81.9898399,96.3118846 80.4663717,106.733131 78.5,107.90625 C76.5416998,109.074554 75.0226745,99.3233823 73.9429241,78.6527344 L74.166848,78.724478 C63.308317,75.5100545 67.0111011,46.542609 76.3042574,38.4840374 C77.1202505,37.776448 78.0467055,37.2308574 79.0836222,36.8472656 C78.7799694,32.5604777 79.3100902,28.520867 80.6727536,24.7282808 C88.3182065,3.44933517 110.140975,-3.14345218 132.006509,3.44933517 Z",
    id: "Combined-Shape",
    fill: "#2c1b18"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g-16",
    transform: "translate(70.000000, 85.000000) scale(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-17",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.58ed40e5a8e6e516ad880a68e4c19349.svg";
export { ForwardRef as ReactComponent };